import { useFormik } from 'formik';
import type { EntrySeccionales } from '../../modules/EntryRequests/types';
import * as Yup from 'yup';

interface UseEntryRequestFormikProps {
  onSubmit: (values: EntrySeccionales) => void;
}

const entrySeccionalesValidationSchema = Yup.object().shape({
  section_id: Yup.string().required('Requerido'),
  // Número de factura
  invoice_number: Yup.string()
    .max(32, 'Máximo 32 caracteres')
    .required('Número de factura es Requerido'),

  section_label: Yup.string().required('Requerido'),
  deliveries: Yup.number().typeError('Debe ser un número').required('Requerido').min(1, 'Debe ser mínimo 1').max(9999999999, 'Máximo 10 dígitos')
});

export const useEntrySeccionales = ({
  onSubmit,
}: UseEntryRequestFormikProps) => {
  return useFormik<EntrySeccionales>({
    initialValues: {
      section_id: '',
      invoice_number: '',
      deliveries: 0,
      section_label: '',
    },
    validationSchema: entrySeccionalesValidationSchema,
    onSubmit,
  });
};
